import React from 'react';
import * as Icon from 'react-bootstrap-icons';
import { Form, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { copyToClipboard } from '../copyToClipboard';

interface FormControlWithClipboardProps extends React.ComponentProps<
  typeof Form.Control
> {
  value: string;
}

export const FormControlWithClipboard: React.FC<
  FormControlWithClipboardProps
> = ({ value, ...props }) => {
  return (
    <InputGroup>
      <Form.Control value={value} {...props} />
      <OverlayTrigger overlay={<Tooltip>Kopiuj</Tooltip>}>
        <InputGroup.Text
          style={{ cursor: 'pointer' }}
          onClick={() => void copyToClipboard(value)}
        >
          <Icon.Copy />
        </InputGroup.Text>
      </OverlayTrigger>
    </InputGroup>
  );
};
